import utility from '../../services/utility';
import {
    colors
} from "../../variables/charts";

let chartProcessingTime = {
    options: {
        scales: {
            y: {
                grid: {
                    color: "#fffff",
                    zeroLineColor: colors.gray[900],
                },
                ticks: {
                    callback: function (value) {
                        return utility.formatMillisecondTime(value);
                    },
                    color: colors.gray[100]
                },
            },
            x: {
                ticks: {
                    color: colors.gray[100]
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        var label = `${context.dataset.label} :` || '';
                        if (context.parsed.y !== null) label += utility.formatMillisecondReadbleTime(context.parsed.y);
                        return label;
                    },
                },
            },
        },
    },
    data: (data) => {
        return {
            labels: data.map(d => utility.formatDateString(d.key, false)),
            datasets: [
                {
                    label: "Average time",
                    data: data.map(d => d.value),
                },
            ],
        };
    },
};

export default chartProcessingTime;